<template>
    <div class="parkinglot_view">
      <loading v-if="loading"/>
      <error />
      <!-- 找停車場_view -->
      <section class="">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="parkinglot-guide" v-on:click="navigation(lot.latitude, lot.longitude)"><i class="fas fa-location-arrow"></i></div>
              <div class="cb"></div>
              <h4 class="section-heading text-uppercase">{{ lot.name }}</h4>
            </div>
          </div>

          <div class="row parkinglot-view-top" v-if="!loading">
            
              <div class="col-md-6">
                <div class="lot-map">
                  <div class="lot-map-img" :style="'background-image: url('+ img +'), url(../img/parkit/parkinglot_default.png);'">
                  </div>
                </div>
              </div>
              <div class="col-md-6 lot-description">
                <dl class="dl-horizontal dl-parkit">
                  <dt>平日收費<i class="fas fa-angle-right"></i></dt>
                  <dd>
                    <ul class="list-unstyled lot-fees lot-fees-3" v-if="lot">
                      <li class="lot-fee-0">
                        <span class="time">{{ lot.weekday_1_start }}:00</span><span>$ {{lot.weekday_1_fee}} / </span><span>hr</span>
                      </li>
                      <li class="lot-fee-1">
                        <span class="time">{{ lot.weekday_2_start }}:00</span><span>$ {{lot.weekday_2_fee}} / </span><span>hr</span>
                      </li>
                        <li class="lot-fee-2">
                        <span class="time">{{ lot.weekday_3_start }}:00</span><span>$ {{lot.weekday_3_fee}} / </span><span>hr</span>
                      </li>
                    </ul>
                  </dd>
        
                <dt>假日收費<i class="fas fa-angle-right"></i></dt>
                 <dd>
                    <ul class="list-unstyled lot-fees lot-fees-3" v-if="lot">
                      <li class="lot-fee-0">
                        <span class="time">{{ lot.weekend_1_start }}:00</span><span>$ {{lot.weekend_1_fee}} / </span><span>hr</span>
                      </li>
                      <li class="lot-fee-1">
                        <span class="time">{{ lot.weekend_2_start }}:00</span><span>$ {{lot.weekend_2_fee}} / </span><span>hr</span>
                      </li>
                        <li class="lot-fee-2">
                        <span class="time">{{ lot.weekend_3_start }}:00</span><span>$ {{lot.weekend_3_fee}} / </span><span>hr</span>
                      </li>
                    </ul>
                  </dd>
        
                  <dt>電話<i class="fas fa-angle-right"></i></dt>
                  <dd>{{ lot.cs_phone }}</dd>
                  <dt>地址<i class="fas fa-angle-right"></i></dt>
                  <dd>{{ lot.zipcode + lot.county + lot.district + lot.addr}}</dd>
                  <!--
                  <dt>信用卡優惠：</dt>
                  <dd>支援市區免費停車優惠</dd>
                  <dt>其他優惠：</dt>
                  <dd>支援時數</dd>
                    -->
                  <dt v-if="lot.description.length">備註<i class="fas fa-angle-right"></i></dt>
                  <dd class="lot-other" v-if="lot.description.length">
                    <ul class="list-unstyled list-inline">
                      <li>
                        <span class="lot-notes">・{{ lot.description }}</span>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
              <div class="clearfix">
              </div>
              
              
          </div>
          <div class="row parkinglot-view-content">
              <dl class="dl-horizontal col-sm-6 dl-parkit dl-mob-fixed">
                <dt>營業時間<i class="fas fa-angle-right"></i></dt>
                <dd>{{ lot.op_time_start }}:00 ~  {{ lot.op_time_end }}:00 </dd>
                <!--<dt>營業項目<i class="fas fa-angle-right"></i></dt>
                <dd class="business-item">
                  <span>月租</span><span>臨停</span>
                </dd>!-->
                <!--
                <dt>月租收費<i class="fas fa-angle-right"></i></dt>
                <dd>【24H】$5000元【日】$1500(平日)</dd>
                !-->
              </dl>
              <dl class="dl-horizontal col-sm-6 dl-parkit">
                <dt>進場方式<i class="fas fa-angle-right"></i></dt>
                <dd v-if="lot.service_type == 0">車牌辨識</dd>
                <dt>停車型態<i class="fas fa-angle-right"></i></dt>
                <dd v-if="lot.environment == 0">室內</dd>
                <dd v-if="lot.environment == 1">室外</dd>
                <dd v-if="lot.environment == 2">車塔</dd>
                <dd v-if="lot.environment == 3">混搭</dd>
                <dt>停車設備<i class="fas fa-angle-right"></i></dt>
                <dd v-if="lot.equip_vendor == 1">平面</dd>
                <dd v-if="lot.equip_vendor == 2">機械</dd>
                <dd v-if="lot.equip_vendor == 3">混合</dd>
              </dl>
              <div class="clearfix"></div>
              </div>
              <div class="btn-back fr">
                <button class="btn btn-primary js-scroll-trigger" @click="$router.go(-1)"><i class="fas fa-chevron-left"></i> BACK</button>
              </div>
              <div class="cb"></div>
          </div>        
      </section>
    </div>
</template>

<script>
export default {
  name: 'ParkinglotView',
  components: {
  },
  props: {
  },
  data() {
    return {
      lot: {},
      loading: true,
      img: "/img/parkit/parkinglot_default.png"
    }
  },
  mounted() {
    var self = this;
    self.getLots()
  },
  methods: {
    navigation: function(lat, lng) {
      window.location.replace("https://www.google.pl/maps/place/" + lat + "," + lng + "/@" + lat + "," + lng + ",13z")
    },
    getLots: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/lots/details?id=' + self.$route.query.id)
        .then((response) => {
          self.lot = response.body
          self.$http.get('https://manager.purealm.com.tw/display_picture.json?lot_code=' + self.lot.code)
            .then((response) => {
              self.img = 'https://manager.purealm.com.tw' + response.body.image_path
            })
          self.loading = false
          document.title = self.lot.name + " - " + process.env.VUE_APP_LOGO
        })
        .catch((response) => {
          self.loading = false
          $("#error-modal").modal("show")
        })
        .finally(() => {
        });
    },
  }
}
</script>